// DenKind redesign 2 (20 Oct 2026): Judge.me review dates in UK style ("9 Oct 2026").
// Judge.me prints dates in its own setting's format. While that setting is mm/dd/yyyy, a UK
// reader takes 10/09/2026 for 10 September, so this rewrites those dates. If the owner switches
// the format in Judge.me (Settings > Review widget), this script leaves the dates alone.
(() => {
  const fmt = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  const usFormat = () => ((window.jdgmSettings || {}).review_date_format || '') === 'mm/dd/yyyy';
  const fix = () => {
    if (!usFormat()) return;
    document.querySelectorAll('.jdgm-widget .jm-text, .jdgm-widget .jdgm-rev__timestamp').forEach((el) => {
      if (el.children.length) return;
      const m = el.textContent.trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (!m) return;
      const d = new Date(Number(m[3]), Number(m[1]) - 1, Number(m[2]));
      if (d.getMonth() !== Number(m[1]) - 1 || d.getDate() !== Number(m[2])) return;
      el.textContent = fmt.format(d);
    });
  };
  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; fix(); });
  };
  const start = () => {
    fix();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
